<template>
  <div class="purchase-order-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "purchaseOrderBase",
};
</script>
